<template>
  <div
    v-if="activated && AttributesGrid[directoryName]"
    :class="$style.sectionRoot"
  >
    <div :class="$style.user_attributes">
      <h2 :class="[$style.user_attributes__title, $style.sectionHeader]">
        {{ title[directoryName] }}
      </h2>
      <StatusBadge
        v-if="isO365AttributesNew"
        :isUppercase="false"
        status="warning"
        :text="'New! Customize the user principal name mapping'"
      />
    </div>
    <div :class="$style.sectionContent">
      <div :class="[$style.span3, $style.intro]">
        <span>
          {{ introParagraph[directoryName] }}
        </span>
        <a
          :href="exportAttributesKbUrl"
          rel="noopener noreferrer"
          target="_blank"
        >
          <em>
            {{ kbLinkText }}
          </em>
        </a>
      </div>
      <component :is="AttributesGrid[directoryName]" />
    </div>
  </div>
</template>

<script>
import { ItemTypeConsts, ItemTypeDisplayNames } from 'client/util/Constants';
import { StatusBadge } from '@jumpcloud/ui-components';
import GSuiteAttributesGrid from 'client/directories/GSuite/GSuiteAttributesGrid.vue';
import O365AttributesGrid from 'client/directories/Office365/O365AttributesGrid.vue';

const gSuite = ItemTypeDisplayNames[ItemTypeConsts.gSuite];
const office365 = ItemTypeDisplayNames[ItemTypeConsts.office365];

export default {
  name: 'UserAttributesExport',

  components: {
    StatusBadge,
    O365AttributesGrid,
    GSuiteAttributesGrid,
  },

  props: {
    activated: {
      type: Boolean,
      required: true,
    },
    directoryName: {
      type: String,
      required: true,
    },
    exportAttributesKbUrl: {
      type: String,
      required: true,
    },
    kbLinkText: {
      type: String,
      default: 'Learn More',
    },
  },

  data() {
    const { directoryName } = this.$props;
    const introParagraph = `You may set the attributes below to Import, Export, or Exclude. For attributes set to Export, JumpCloud is the source of record and will override the corresponding attribute values in ${directoryName} for bound users. For attributes set to Import, JumpCloud will sync these attributes from ${directoryName} when importing new users.`;
    const o365IntroParagraph = `You may set the attributes below to Export or Exclude. For attributes set to Export, JumpCloud is the source of record and will override the corresponding attribute values in ${directoryName} for bound users.`;

    return {
      title: {
        [gSuite]: 'Attribute mapping and settings',
        [office365]: 'Attribute mapping and settings',
      },
      introParagraph: {
        [gSuite]: introParagraph,
        [office365]: o365IntroParagraph,
      },
      AttributesGrid: {
        [gSuite]: GSuiteAttributesGrid,
        [office365]: O365AttributesGrid,
      },
    };
  },

  computed: {
    isO365AttributesNew() {
      return this.directoryName === office365;
    },
  },
};
</script>

<style module>
@import "../../css/sections.css";

.user_attributes {
  display: flex;
}

.user_attributes__title {
  flex-basis: 30%;
}

.intro {
  margin-bottom: 25px;
}
</style>
